/**
 * Performance shortcuts.
 */
import { PerformanceTracking } from "../../features/analytics/performance";

type ResourceType = "script" | "stylesheet" | "image" | "font" | "xhr" | "fetch" | "other";

export class PerformanceTracker {
  constructor(public readonly client: PerformanceTracking) {}

  /** Report Core Web Vitals (LCP/FID/CLS/INP/TTFB). */
  webVitals(pageUrl: string, vitals: Record<string, number>) {
    return this.client.trackWebVitals({ pageUrl, ...vitals });
  }

  /** Report page-load timing. */
  pageLoad(pageUrl: string, timings: Record<string, number>) {
    return this.client.trackPageLoad({ pageUrl, ...timings });
  }

  /** Report a single resource load. */
  resource(pageUrl: string, resourceUrl: string, resourceType: ResourceType, duration: number) {
    return this.client.trackResource({ pageUrl, resourceUrl, resourceType, duration });
  }

  /** Auto-collect Core Web Vitals + navigation timing from the browser. */
  autoTrack(options?: { userId?: string; resources?: boolean; minDuration?: number }) {
    return this.client.autoTrack(options);
  }
}
